export class ContactFunctionFilter {
    public IncludeInactive?: boolean;
}

export default ContactFunctionFilter;